
export default function FlashCatalogSection() {
    const flashes = [
        {
            title: 'Fine Line Floral',
            description: 'Diseños delicados de rosas y hojas. Disponibles para antebrazo o costillas.',
            image: '/images/flash-floral.png',
            price: 'Desde $50.000',
            status: 'Disponible'
        },
        {
            title: 'Ornamental & Geométrico',
            description: 'Piezas de puntillismo y geometría sagrada. Ideales para zonas planas.',
            image: '/images/flash-ornamental.png',
            price: 'Desde $60.000',
            status: 'Últimos Cupos'
        },
        {
            title: 'Micro Realismo',
            description: 'Mariposas, abejas y estrellas con alto nivel de detalle.',
            image: '/images/flash-micro.png',
            price: 'Desde $45.000',
            status: 'Disponible'
        }
    ];

    return (
        <section id="flashes" className="py-20 bg-pink-50">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                        Catálogo de <span className="text-pink-500">Flash Tattoo</span>
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Diseños exclusivos creados por nuestras artistas, listos para ser tatuados.
                        Se reservan con abono previo. ¡No te quedes sin el tuyo!
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                    {flashes.map((flash, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
                        >
                            <div className="relative h-80 overflow-hidden bg-gray-100">
                                <img
                                    src={flash.image}
                                    alt={flash.title}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-pink-600 shadow-sm">
                                    {flash.status}
                                </div>
                            </div>

                            <div className="p-6">
                                <div className="flex justify-between items-start mb-2">
                                    <h3 className="text-xl font-bold text-gray-900">{flash.title}</h3>
                                    <span className="text-gray-900 font-bold bg-gray-100 px-2 py-1 rounded text-sm">{flash.price}</span>
                                </div>

                                <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                                    {flash.description}
                                </p>

                                <a
                                    href={`https://wa.me/56982504829?text=Hola,%20me%20interesa%20reservar%20un%20flash%20del%20set%20${encodeURIComponent(flash.title)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-full block text-center bg-gray-900 text-white py-3 rounded-lg font-semibold hover:bg-pink-500 transition-colors"
                                >
                                    Reservar Diseño
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
